import React from 'react'
import { DesktopOnly } from 'components/styled'
import HeaderLogo from 'components/headerLogo'
import Menu from 'components/menu'
import LoggedUser from 'components/loggedUser'
import * as S from './styles'

export const Header = () => {
  return (
    <S.ContainerArea id='idContainerArea'>
      <S.Area>
        <S.Container data-test='container_header'>
          <S.LinkContainer mobileOnly>
            <Menu />
          </S.LinkContainer>
          <DesktopOnly>
            <S.Explore>
              <S.StyledShoppingBag />
              <a href='https://www.cobasi.com.br'>
                Explore a Cobasi
              </a>
            </S.Explore>
          </DesktopOnly>
          <HeaderLogo />
          <DesktopOnly>
            <S.LinkContainer data-test='link-container-header'>
              <LoggedUser />
            </S.LinkContainer>
          </DesktopOnly>
        </S.Container>
      </S.Area>
    </S.ContainerArea>
  )
}

export default Header
